import Mobile from './Mobile';
import Shipping from './Shipping';
import Email from './Email';
import Register_Country from './Register_Country';
import t from 'tcomb';

const Domicile = t.struct({
  name: t.Str,
  surname: t.Str,
  address: t.Str,
  co: t.maybe(t.Str),
  town: t.Str,
  district: t.Str,
  zip: t.Str,
  email: Email,
  mobile: Mobile,
  alt_email: t.maybe(Email),
  alt_mobile: t.maybe(Mobile),
  shipping: t.maybe(Shipping),
  mobile_country: t.maybe(Register_Country)
}, 'Domicile');


module.exports = Domicile;




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Domicile.js
 **/